const DeepCallLogo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 448 482"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M447.785 223.931H223.935C194.534 223.936 165.421 218.148 138.257 206.897C111.094 195.646 86.4118 179.153 65.6207 158.358C44.8301 137.564 28.3374 112.876 17.0852 85.7047C5.83299 58.5333 0.0415033 29.4106 0.0415039 0H223.935C283.3 0.011367 340.23 23.6077 382.208 65.6002C424.185 107.593 447.773 164.544 447.785 223.931Z"
        fill="url(#paint0_linear_127_223)"
      />
      <path
        style={{ mixBlendMode: "multiply" }}
        d="M447.785 223.931H223.935C194.534 223.936 165.421 218.148 138.257 206.897C111.094 195.646 86.4118 179.153 65.6207 158.358C44.8301 137.564 28.3374 112.876 17.0852 85.7047C5.83299 58.5333 0.0415033 29.4106 0.0415039 0L68.3581 9.47515C217.445 30.1745 353.086 106.81 447.785 223.845V223.931Z"
        fill="url(#paint1_linear_127_223)"
      />
      <path
        d="M211.85 257.244H447.571V286.398C447.571 338.022 427.071 387.532 390.581 424.035C354.091 460.54 304.599 481.046 252.994 481.046H0V468.999C0.0340902 412.819 22.3703 358.952 62.0973 319.243C101.825 279.533 155.69 257.233 211.85 257.244Z"
        fill="url(#paint2_linear_127_223)"
      />
      <path
        style={{ mixBlendMode: "multiply" }}
        d="M447.786 257.03H223.893C164.516 257.041 107.575 280.642 65.5894 322.643C23.6037 364.643 0.0113629 421.605 0 481.003L68.5736 471.528C217.665 450.841 353.311 374.204 448 257.158L447.786 257.03Z"
        fill="url(#paint3_linear_127_223)"
      />

      <defs>
        <linearGradient
          id="paint0_linear_127_223"
          x1="403.34"
          y1="-68.1696"
          x2="-72.2614"
          y2="408.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9B2985" />
          <stop offset="0.51" stopColor="#E8455C" />
          <stop offset="1" stopColor="#EC6F2B" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_127_223"
          x1="241.249"
          y1="71.3423"
          x2="197.893"
          y2="172.899"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B667A5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>

        <linearGradient
          id="paint2_linear_127_223"
          x1="534.36"
          y1="62.4676"
          x2="58.7153"
          y2="539.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9B2985" />
          <stop offset="0.51" stopColor="#E8455C" />
          <stop offset="1" stopColor="#EC6F2B" />
        </linearGradient>

        <linearGradient
          id="paint3_linear_127_223"
          x1="241.251"
          y1="409.661"
          x2="197.851"
          y2="308.061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B667A5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DeepCallLogo;